import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  BasicOptions,
  ClaimsOptions,
  ComprehensiveOptions,
  StandardOptions,
} from "./PricingOptions";
import { useNavigate } from "react-router-dom";
import { useScreenSize, useCustomScreen } from "../Utils";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";

export default function PricingSection() {
  const navigate = useNavigate();

  function loginNavigateHandler() {
    localStorage.setItem("login-from", "Reports");
    if (localStorage.getItem("token")) {
      navigate("/profile/billing-info");
    } else {
      navigate("/login");
    }
  }

  function renderPricingOptionIcon(available) {
    if (available) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          fill="currentColor"
          className="bi bi-check"
          viewBox="0 0 16 16"
          style={{ color: "#57C0D1", top: "6px", left: "-10px" }}
        >
          <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
        </svg>
      );
    }
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        fill="currentColor"
        className="bi bi-x"
        viewBox="0 0 16 16"
      >
        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
      </svg>
    );
  }

  const [showModal, setShowModal] = useState(false);
  const [reportType, setReportType] = useState("");
  const [isAustraliaSample, setIsAustraliaSample] = useState(false);

  const handleRenderSampleReport = (type, isAU = false) => {
    setReportType(type);
    setIsAustraliaSample(isAU);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();

  const reportData = [
    {
      tabType: "BASIC Report",
      imageSrc: "/images/basicThumbnail.jpeg",
      sampleReport: ["/images/Basic_Sample_page.jpg"],
      sampleReportAU: ["/images/Metric_Basic_pages-to-jpg-0001.jpg"],
    },
    {
      tabType: "STANDARD Report",
      imageSrc: "/images/standardThumbnail.jpeg",
      sampleReport: ["/images/Standard_Sample_page.jpg"],
      sampleReportAU: ["/images/Metric_Standard_page-0001.jpg"],
    },
    {
      tabType: "COMPREHENSIVE Report",
      imageSrc: "/images/comprehensiveThumbnail_1.jpeg",
      subImgSrc: "/images/comprehensiveSample_page-02.jpg",
      sampleReport: [
        "/images/comprehensiveSample_page-01.jpg",
        "/images/comprehensiveSample_page-02.jpg",
        "/images/comprehensiveSample_page-03.jpg",
        "/images/comprehensiveSample_page-04.jpg",
        "/images/comprehensiveSample_page-05.jpg",
        "/images/comprehensiveSample_page-06.jpg",
      ],
      sampleReportAU: [
        "/images/Metric_Comprehension_page-0001.jpg",
        "/images/Metric_Comprehension_page-0002.jpg",
        "/images/Metric_Comprehension_page-0003.jpg",
        "/images/Metric_Comprehension_page-0004.jpg",
        "/images/Metric_Comprehension_page-0005.jpg",
        "/images/Metric_Comprehension_page-0006.jpg",
      ],
    },
    {
      tabType: "CLAIMS Report",
      imageSrc: "/images/claimsThumbnail.jpeg",
      sampleReport: ["/images/Claims_Sample_page.jpg"],
      // No AU sample for Claims — will fall back to US
    },
  ];

  return (
    <section id="contact" className="contact">
      <header className="section-header my-5">
        <h1
          className=" mb-3  "
          style={{
            fontWeight: "bold",
            textAlign: "center",
            fontSize: is4kScreen
              ? "5.3rem"
              : isXxlScreen
              ? "2.8rem"
              : isXlScreen
              ? "2.7rem"
              : isIpadProPortrait
              ? "3rem"
              : isLargeScreen
              ? "2.4rem"
              : isMediumScreen
              ? "2.4rem"
              : "2rem",
            paddingTop: is4kScreen
              ? "6rem"
              : isXxlScreen
              ? "2rem"
              : isXlScreen
              ? "2rem"
              : isIpadProPortrait
              ? "3rem"
              : isLargeScreen
              ? "1.5rem"
              : isMediumScreen
              ? "2rem"
              : "2.5rem",
          }}
        >
          Exactly what you need, nothing more
        </h1>
        <p
          className="px-2 px-md-5"
          style={{
            fontSize: is4kScreen
              ? "2.9rem"
              : isXxlScreen
              ? "1.7rem"
              : isXlScreen
              ? "1.4rem"
              : isIpadProPortrait
              ? "2rem"
              : isLargeScreen
              ? "1.5rem"
              : isMediumScreen
              ? "1.4rem"
              : "1.3rem",
            fontWeight: "200",
          }}
        >
          Our reports are comprehensive, easy to use, and don't include
          information you'll never use.
        </p>
      </header>
      <div className="container">
        <div className="pricing">
          <div className="row">
            {/* BASIC */}
            <div
              className={`col-lg-${isIpadProPortrait ? "6" : "3"} aos-init aos-animate`}
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div
                className="box mb-3"
                style={{
                  padding: is4kScreen
                    ? "2rem"
                    : isXxlScreen
                    ? "1.5rem"
                    : isXlScreen
                    ? "2rem"
                    : isIpadProPortrait
                    ? "1rem"
                    : isLargeScreen
                    ? "0.8rem"
                    : isMediumScreen
                    ? "1.5rem"
                    : "1rem",
                }}
              >
                <span className="base1">.PDF</span>
                <h3
                  id=""
                  className="mt-2 mb-3"
                  style={{
                    fontSize: is4kScreen
                      ? "2.4rem"
                      : isXxlScreen
                      ? "1.7rem"
                      : isXlScreen
                      ? "1.5rem "
                      : isIpadProPortrait
                      ? "2.3rem"
                      : isLargeScreen
                      ? "1.1rem"
                      : isMediumScreen
                      ? "1.8rem"
                      : "",
                  }}
                >
                  BASIC
                </h3>
                <h4
                  id=""
                  style={{
                    color: "#4E585A",
                    fontSize: is4kScreen
                      ? "4.8rem"
                      : isXxlScreen
                      ? ""
                      : isXlScreen
                      ? ""
                      : isIpadProPortrait
                      ? "3.6rem"
                      : isLargeScreen
                      ? "2.5rem"
                      : "",
                  }}
                  className="mb-3"
                >
                  <sup
                    style={{
                      fontSize: is4kScreen
                        ? "3rem"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? ""
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? "1.5rem"
                        : "",
                    }}
                  >
                    $
                  </sup>
                  20 <sup>USD</sup>
                </h4>
                <ul className="mb-4">
                  {BasicOptions.initialInfo.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen
                            ? "10px 0 10px 10px"
                            : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                  <p
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? "1.3rem "
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : "1.3rem",
                      paddingTop: "1rem",
                    }}
                  >
                    Wire Diagram:
                  </p>
                  {BasicOptions.wireDiagram.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen
                            ? "10px 0 10px 10px"
                            : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                  <p
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? "1.3rem "
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : "1.3rem",
                      paddingTop: "1rem",
                    }}
                  >
                    Measurements:
                  </p>
                  {BasicOptions.measurements.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen
                            ? "10px 0 10px 10px"
                            : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                </ul>
                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                  <button
                    onClick={() => handleRenderSampleReport("BasicReport", false)}
                    className="buy-btn"
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1.0rem"
                        : isXlScreen
                        ? " 0.8rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1rem"
                        : "",
                      background: "#ffffff",
                      padding: is4kScreen
                        ? ""
                        : isXxlScreen
                        ? "8px 10px"
                        : isXlScreen
                        ? "10px 10px"
                        : isLargeScreen
                        ? "2px 10px"
                        : "8px 25px",
                    }}
                  >
                    US/Canada Example
                  </button>
                  <button
                    onClick={() => handleRenderSampleReport("BasicReport", true)}
                    className="buy-btn"
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1.0rem"
                        : isXlScreen
                        ? " 0.8rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1rem"
                        : "",
                      background: "#ffffff",
                      padding: is4kScreen
                        ? ""
                        : isXxlScreen
                        ? "8px 10px"
                        : isXlScreen
                        ? "10px 10px"
                        : isLargeScreen
                        ? "2px 10px"
                        : "8px 25px",
                    }}
                  >
                    Australia Example
                  </button>
                </div>
                <Link to="/order-page">
                  <button
                    className="buy-btn1"
                    onClick={loginNavigateHandler}
                    style={{
                      marginTop: "25px",
                      float: "right",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1.1rem"
                        : isXlScreen
                        ? " 0.9rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1rem"
                        : "",
                      padding: is4kScreen
                        ? ""
                        : isXxlScreen
                        ? "5px 15px"
                        : isXlScreen
                        ? "2px 10px"
                        : isLargeScreen
                        ? "2px 10px"
                        : "8px 25px",
                      borderRadius: isLargeScreen ? "1.4rem" : "",
                      width: is4kScreen
                        ? "12rem"
                        : isXxlScreen
                        ? "7rem"
                        : isXlScreen
                        ? "6rem"
                        : isIpadProPortrait
                        ? "14rem"
                        : "",
                    }}
                  >
                    Order
                  </button>
                </Link>
              </div>
            </div>

            {/* STANDARD */}
            <div
              className={`col-lg-${isIpadProPortrait ? "6" : "3"} mt-4 mt-lg-0 aos-init aos-animate`}
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div
                className="box mb-3"
                style={{
                  padding: is4kScreen
                    ? "2rem"
                    : isXxlScreen
                    ? "1.5rem"
                    : isXlScreen
                    ? "2rem"
                    : isLargeScreen
                    ? "0.8rem"
                    : isMediumScreen
                    ? "1.5rem"
                    : "1rem",
                }}
              >
                <span className="base2">.PDF</span>
                <h3
                  id="special-h3"
                  className="mt-2 mb-3"
                  style={{
                    fontSize: is4kScreen
                      ? "2.4rem"
                      : isXxlScreen
                      ? "1.7rem"
                      : isXlScreen
                      ? "1.5rem "
                      : isIpadProPortrait
                      ? "2.3rem"
                      : isLargeScreen
                      ? "1.1rem"
                      : isMediumScreen
                      ? "1.8rem"
                      : "",
                  }}
                >
                  STANDARD
                </h3>
                <h4
                  id="special-h4"
                  style={{
                    color: "#4E585A",
                    fontSize: is4kScreen
                      ? "4.8rem"
                      : isIpadProPortrait
                      ? "3.6rem"
                      : isLargeScreen
                      ? ""
                      : "",
                  }}
                  className="mb-3"
                >
                  <sup
                    style={{
                      fontSize: is4kScreen
                        ? "3rem"
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? ""
                        : "",
                    }}
                  >
                    $
                  </sup>
                  30 <sup>USD</sup>
                </h4>
                <ul className="mb-4">
                  {BasicOptions.initialInfo.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen ? "10px 0 10px 10px" : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                  <p
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? "1.3rem "
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : "1.3rem",
                      paddingTop: "1rem",
                    }}
                  >
                    Wire Diagram:
                  </p>
                  {StandardOptions.wireDiagram.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen ? "10px 0 10px 10px" : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                  <p
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? "1.3rem "
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : "1.3rem",
                      paddingTop: "1rem",
                    }}
                  >
                    Measurements:
                  </p>
                  {StandardOptions.measurements.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen ? "10px 0 10px 10px" : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                </ul>
                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                  <button
                    onClick={() => handleRenderSampleReport("StandardReport", false)}
                    className="buy-btn"
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1.0rem"
                        : isXlScreen
                        ? " 0.8rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1rem"
                        : "",
                      background: "#ffffff",
                      padding: is4kScreen
                        ? ""
                        : isXxlScreen
                        ? "8px 10px"
                        : isXlScreen
                        ? "10px 10px"
                        : isLargeScreen
                        ? "2px 10px"
                        : "8px 25px",
                    }}
                  >
                    US/Canada Example
                  </button>
                  <button
                    onClick={() => handleRenderSampleReport("StandardReport", true)}
                    className="buy-btn"
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1.0rem"
                        : isXlScreen
                        ? " 0.8rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1rem"
                        : "",
                      background: "#ffffff",
                      padding: is4kScreen
                        ? ""
                        : isXxlScreen
                        ? "8px 10px"
                        : isXlScreen
                        ? "8px 10px"
                        : isLargeScreen
                        ? "2px 10px"
                        : "8px 25px",
                    }}
                  >
                    Australia Example
                  </button>
                </div>
                <Link to="/order-page">
                  <button
                    className="buy-btn1"
                    onClick={loginNavigateHandler}
                    style={{
                      marginTop: "25px",
                      float: "right",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1.1rem"
                        : isXlScreen
                        ? " 0.9rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1rem"
                        : "",
                      padding: is4kScreen
                        ? ""
                        : isXxlScreen
                        ? "5px 15px"
                        : isXlScreen
                        ? "2px 10px"
                        : isLargeScreen
                        ? "2px 10px"
                        : "8px 25px",
                      borderRadius: isLargeScreen ? "1.4rem" : "",
                      width: is4kScreen
                        ? "12rem"
                        : isXxlScreen
                        ? "7rem"
                        : isXlScreen
                        ? "6rem"
                        : isIpadProPortrait
                        ? "14rem"
                        : "",
                    }}
                  >
                    Order
                  </button>
                </Link>
              </div>
            </div>

            {/* COMPREHENSIVE */}
            <div
              className={`col-lg-${isIpadProPortrait ? "6" : "3"} mt-4 mt-lg-${isIpadProPortrait ? "4" : "0"} aos-init aos-animate`}
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div
                className="box mb-3"
                style={{
                  padding: is4kScreen
                    ? "2rem"
                    : isXxlScreen
                    ? "1.5rem"
                    : isXlScreen
                    ? "2rem"
                    : isLargeScreen
                    ? "0.8rem"
                    : isMediumScreen
                    ? "1.5rem"
                    : "1rem",
                }}
              >
                <span className="base3">.PDF</span>
                <h3
                  id="special-h3"
                  className="mt-2 mb-3 "
                  style={{
                    fontSize: is4kScreen
                      ? "2.4rem"
                      : isXxlScreen
                      ? "1.7rem"
                      : isXlScreen
                      ? "1.5rem "
                      : isIpadProPortrait
                      ? "2.3rem"
                      : isLargeScreen
                      ? "1.1rem"
                      : isMediumScreen
                      ? "1.8rem"
                      : "",
                  }}
                >
                  COMPREHENSIVE
                </h3>
                <h4
                  id="special-h4"
                  style={{
                    color: "#4E585A",
                    fontSize: is4kScreen
                      ? "4.8rem"
                      : isIpadProPortrait
                      ? "3.6rem"
                      : isLargeScreen
                      ? ""
                      : "",
                  }}
                  className="mb-3"
                >
                  <sup
                    style={{
                      fontSize: is4kScreen
                        ? "3rem"
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? ""
                        : "",
                    }}
                  >
                    $
                  </sup>
                  45 <sup>USD</sup>
                </h4>
                <ul className="mb-4">
                  {BasicOptions.initialInfo.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen ? "10px 0 10px 10px" : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                  <p
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? "1.3rem "
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : "1.3rem",
                      paddingTop: "1rem",
                    }}
                  >
                    Wire Diagram:
                  </p>
                  {ComprehensiveOptions.wireDiagram.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen ? "10px 0 10px 10px" : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                  <p
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? "1.3rem "
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : "1.3rem",
                      paddingTop: "1rem",
                    }}
                  >
                    Measurements:
                  </p>
                  {ComprehensiveOptions.measurements.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen ? "10px 0 10px 10px" : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                </ul>
                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                  <button
                    onClick={() => handleRenderSampleReport("ComprehensiveReport", false)}
                    className="buy-btn"
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1.0rem"
                        : isXlScreen
                        ? " 0.8rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1rem"
                        : "",
                      background: "#ffffff",
                      padding: is4kScreen
                        ? ""
                        : isXxlScreen
                        ? "8px 10px"
                        : isXlScreen
                        ? "10px 10px"
                        : isLargeScreen
                        ? "2px 10px"
                        : "8px 25px",
                    }}
                  >
                    US/Canada Example
                  </button>
                  <button
                    onClick={() => handleRenderSampleReport("ComprehensiveReport", true)}
                    className="buy-btn"
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1.0rem"
                        : isXlScreen
                        ? " 0.8rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1rem"
                        : "",
                      background: "#ffffff",
                      padding: is4kScreen
                        ? ""
                        : isXxlScreen
                        ? "8px 10px"
                        : isXlScreen
                        ? "8px 10px"
                        : isLargeScreen
                        ? "2px 10px"
                        : "8px 25px",
                    }}
                  >
                    Australia Example
                  </button>
                </div>
                <Link to="/order-page">
                  <button
                    className="buy-btn1"
                    onClick={loginNavigateHandler}
                    style={{
                      marginTop: "25px",
                      float: "right",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1.1rem"
                        : isXlScreen
                        ? " 0.9rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1rem"
                        : "",
                      padding: is4kScreen
                        ? ""
                        : isXxlScreen
                        ? "5px 15px"
                        : isXlScreen
                        ? "2px 10px"
                        : isLargeScreen
                        ? "2px 10px"
                        : "8px 25px",
                      borderRadius: isLargeScreen ? "1.4rem" : "",
                      width: is4kScreen
                        ? "12rem"
                        : isXxlScreen
                        ? "7rem"
                        : isXlScreen
                        ? "6rem"
                        : isIpadProPortrait
                        ? "14rem"
                        : "",
                    }}
                  >
                    Order
                  </button>
                </Link>
              </div>
            </div>

            {/* CLAIMS */}
            <div
              className={`col-lg-${isIpadProPortrait ? "6" : "3"} mt-4 mt-lg-${isIpadProPortrait ? "4" : "0"} aos-init aos-animate`}
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div
                className="box mb-3"
                style={{
                  padding: is4kScreen
                    ? "2rem"
                    : isXxlScreen
                    ? "1.5rem"
                    : isXlScreen
                    ? "2rem"
                    : isLargeScreen
                    ? "0.8rem"
                    : isMediumScreen
                    ? "1.5rem"
                    : "1rem",
                }}
              >
                <span className="base4">.ESX</span>
                <h3
                  id="special-h3"
                  className="mt-2 mb-3"
                  style={{
                    fontSize: is4kScreen
                      ? "2.4rem"
                      : isXxlScreen
                      ? "1.7rem"
                      : isXlScreen
                      ? "1.5rem "
                      : isIpadProPortrait
                      ? "2.3rem"
                      : isLargeScreen
                      ? "1.1rem"
                      : isMediumScreen
                      ? "1.8rem"
                      : "",
                  }}
                >
                  CLAIMS
                </h3>
                <h4
                  id="special-h4"
                  style={{
                    color: "#4E585A",
                    fontSize: is4kScreen
                      ? "4.8rem"
                      : isIpadProPortrait
                      ? "3.6rem"
                      : isLargeScreen
                      ? ""
                      : "",
                  }}
                  className="mb-3"
                >
                  <sup
                    style={{
                      fontSize: is4kScreen
                        ? "3rem"
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? ""
                        : "",
                    }}
                  >
                    $
                  </sup>
                  35 <sup>USD</sup>
                </h4>
                <ul className="mb-4">
                  {BasicOptions.initialInfo.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen ? "10px 0 10px 10px" : "",
                          lineHeight: isIpadProPortrait ? "2rem" : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                  <p
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? "1.3rem "
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : "1.3rem",
                      paddingTop: "1rem",
                    }}
                  >
                    Wire Diagram:
                  </p>
                  {ClaimsOptions.wireDiagram.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen ? "10px 0 10px 10px" : "",
                          lineHeight: isIpadProPortrait ? "30px" : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                  <p
                    style={{
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? "1.3rem"
                        : isXlScreen
                        ? "1.3rem "
                        : isIpadProPortrait
                        ? "2rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : "1.3rem",
                      paddingTop: "1rem",
                    }}
                  >
                    Measurements:
                  </p>
                  {ClaimsOptions.measurements.map((item) => {
                    const { id, option, available } = item;
                    return (
                      <li
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.28rem"
                            : isXlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1.2rem",
                          padding: is4kScreen ? "10px 0 10px 10px" : "",
                        }}
                        className={available ? "" : "na"}
                        key={id}
                      >
                        {renderPricingOptionIcon(available)} {option}
                      </li>
                    );
                  })}
                </ul>
                <div style={{ display: "flex", justifyContent: "right", }}>
                  <button
                    onClick={() => handleRenderSampleReport("ClaimsReport", false)}
                    className="buy-btn"
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1.0rem"
                        : isXlScreen
                        ? " 0.8rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1rem"
                        : "",
                      background: "#ffffff",
                      padding: is4kScreen
                        ? ""
                        : isXxlScreen
                        ? "8px 10px"
                        : isXlScreen
                        ? "10px 10px"
                        : isLargeScreen
                        ? "2px 10px"
                        : "8px 25px",
                    }}
                  >
                    US/Canada Example
                  </button>
                  
                </div>
                <Link to="/order-page">
                  <button
                    className="buy-btn1"
                    onClick={loginNavigateHandler}
                    style={{
                      marginTop: "25px",
                      float: "right",
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? "1.1rem"
                        : isXlScreen
                        ? " 0.9rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1rem"
                        : "",
                      padding: is4kScreen
                        ? ""
                        : isXxlScreen
                        ? "5px 15px"
                        : isXlScreen
                        ? "2px 10px"
                        : isLargeScreen
                        ? "2px 10px"
                        : "8px 25px",
                      borderRadius: isLargeScreen ? "1.4rem" : "",
                      width: is4kScreen
                        ? "12rem"
                        : isXxlScreen
                        ? "7rem"
                        : isXlScreen
                        ? "6rem"
                        : isIpadProPortrait
                        ? "14rem"
                        : "",
                    }}
                  >
                    Order
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SAMPLE REPORT MODAL */}
      <Modal
        show={showModal}
        onHide={handleClose}
        onClick={(e) => e.stopPropagation()}
        centered
        scrollable
        backdrop="static"
      >
        <ModalHeader closeButton style={{ background: "lightblue" }}>
          <ModalTitle>Full Sample</ModalTitle>
        </ModalHeader>
        <ModalBody style={{ height: "80vh" }} className="hide-scrollbar embed-responsive">
          {(() => {
            let images = [];
            if (reportType === "BasicReport") {
              images = isAustraliaSample ? reportData[0].sampleReportAU : reportData[0].sampleReport;
            } else if (reportType === "StandardReport") {
              images = isAustraliaSample ? reportData[1].sampleReportAU : reportData[1].sampleReport;
            } else if (reportType === "ComprehensiveReport") {
              images = isAustraliaSample ? reportData[2].sampleReportAU : reportData[2].sampleReport;
            } else if (reportType === "ClaimsReport") {
              // No AU sample for Claims → always use US
              images = reportData[3].sampleReport;
            }
            return images.map((file, ind) => (
              <img
                key={ind}
                src={file}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  marginTop: "0.5rem",
                  objectFit: "contain",
                  border: "1px solid #000",
                }}
              />
            ));
          })()}
        </ModalBody>
      </Modal>

      <header className="section-header mt-4 px-2">
        <p
          className=""
          style={{
            fontSize: is4kScreen
              ? "2.7rem"
              : isIpadProPortrait
              ? "2.3rem"
              : isLargeScreen
              ? "1.7rem"
              : " 1.3rem",
          }}
        >
          <strong>In a hurry?</strong> Get the report in less than a business
          day with <u>RUSH DELIVERY</u>: <strong>$15 USD/report.</strong>
        </p>
      </header>
    </section>
  );
}